import { projectNamespace } from "../core/namespace"

export const actionsNamespace = `${projectNamespace}actions/`
